module.exports = __webpack_public_path__ + "static/media/payer@2x.fe541d30.png";